module.exports = __webpack_public_path__ + "static/39FEA2_5_0-6c59fd6c2032fa3a9ad846f5819eb183.woff2";